const EVM_NETWORK_DEFINITIONS = [
    {
        id: 'Avalanche',
        network: 'Avalanche',
        nativeSymbol: 'AVAX',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'avalanche-2',
    },
    {
        id: 'Ethereum',
        network: 'Ethereum',
        nativeSymbol: 'ETH',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'ethereum',
        priceFeed: true,
    },
    {
        id: 'BinanceSmartChain',
        network: 'BNB Smart Chain',
        nativeSymbol: 'BNB',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'binancecoin',
    },
    {
        id: 'Localhost',
        network: 'Localhost',
        nativeSymbol: 'ETH',
        kind: 'evm',
        currency: 'USD',
    },
    {
        id: 'ImmutableX',
        network: 'Immutable zkEVM',
        nativeSymbol: 'IMX',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'immutable-x',
    },
    {
        id: 'ApeChain',
        network: 'Ape Chain',
        nativeSymbol: 'APE',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'apecoin',
    },
    {
        id: 'Beam',
        network: 'Beam',
        nativeSymbol: 'BEAM',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'beam-2',
    },
    {
        id: 'ArbitrumOne',
        network: 'Arbitrum One',
        nativeSymbol: 'ETH',
        kind: 'evm',
        currency: 'USD',
    },
    {
        id: 'Monad',
        network: 'Monad',
        nativeSymbol: 'MON',
        displayLabel: 'MONAD',
        kind: 'evm',
        currency: 'USD',
        coingeckoId: 'monad',
        priceFeed: true,
    },
];
const SVM_NETWORK_DEFINITIONS = [
    {
        id: 'Solana',
        network: 'Solana',
        nativeSymbol: 'SOL',
        displayLabel: 'SOLANA',
        kind: 'svm',
        currency: 'USD',
        coingeckoId: 'solana',
        priceFeed: true,
    },
];
export const NETWORK_DEFINITIONS = [
    ...EVM_NETWORK_DEFINITIONS,
    ...SVM_NETWORK_DEFINITIONS,
];
function toChainEnum(definitions) {
    return Object.fromEntries(definitions.map((definition) => [definition.id, definition.network]));
}
export const EVMChain = toChainEnum(EVM_NETWORK_DEFINITIONS);
export const SVMChain = toChainEnum(SVM_NETWORK_DEFINITIONS);
export const NETWORK_BY_NAME = Object.fromEntries(NETWORK_DEFINITIONS.map((definition) => [definition.network, definition]));
export const SYMBOL_BY_NETWORK = Object.fromEntries(NETWORK_DEFINITIONS.map((definition) => [definition.network, definition.nativeSymbol]));
export const getNetworkDefinition = (network) => {
    if (!network)
        return undefined;
    return NETWORK_BY_NAME[network];
};
export const getNativeSymbol = (network) => {
    return getNetworkDefinition(network)?.nativeSymbol ?? 'Unknown';
};
export const getDisplayLabel = (network) => {
    const definition = getNetworkDefinition(network);
    if (!definition)
        return network ?? 'Unknown';
    return 'displayLabel' in definition && definition.displayLabel
        ? definition.displayLabel
        : definition.nativeSymbol;
};
export const getPriceFeedTokens = () => {
    const seenCoingeckoIds = new Set();
    return NETWORK_DEFINITIONS.flatMap((definition) => {
        if (!('priceFeed' in definition) || !definition.priceFeed)
            return [];
        if (!('coingeckoId' in definition) || !definition.coingeckoId)
            return [];
        if (seenCoingeckoIds.has(definition.coingeckoId))
            return [];
        seenCoingeckoIds.add(definition.coingeckoId);
        return [
            {
                network: definition.network,
                symbol: definition.nativeSymbol,
                coingeckoId: definition.coingeckoId,
            },
        ];
    });
};
export const getPriceFeedSymbols = () => {
    return getPriceFeedTokens().map((token) => token.symbol);
};
export const isEvmNetwork = (network) => {
    return !!network && Object.values(EVMChain).includes(network);
};
export const isSvmNetwork = (network) => {
    return !!network && Object.values(SVMChain).includes(network);
};
